module.exports = __webpack_public_path__ + "static/media/3-fells-07_15_2020.290299b0.jpg";